import { render, staticRenderFns } from "./ServicePendencyD.vue?vue&type=template&id=3256010f&scoped=true"
import script from "./ServicePendencyD.vue?vue&type=script&lang=js"
export * from "./ServicePendencyD.vue?vue&type=script&lang=js"
import style0 from "./ServicePendencyD.vue?vue&type=style&index=0&id=3256010f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256010f",
  null
  
)

export default component.exports